import React from 'react'
import Link from 'next/link'

import Card from '@dashboard/components/Card'
import CardHeader from '@dashboard/components/CardHeader'
import Button from '@dashboard/components/Button'
import ToggleOption from '@dashboard/components/ToggleOption'
import Flex from '@dashboard/components/Flex'

import {
  getDescription,
  getDescriptionGeneric,
} from '@dashboard/lib/myers_briggs'

import { Profile } from '@dashboard/lib/types'

import css from './styles.module.scss'

interface OwnProps {
  profile: Profile
  generic?: boolean
  emptyStateCta?: {
    text: string
    onClick: () => void
    showSampleLink?: boolean
  }
}

class MyersBriggsModule extends React.Component<OwnProps> {
  render() {
    const { profile, generic, emptyStateCta } = this.props

    if (emptyStateCta) return this.renderEmptyState(emptyStateCta)
    else if (!profile || !profile.myers_briggs_text_type) return null

    const mbType = profile.myers_briggs_text_type
      ? profile.myers_briggs_text_type
      : ''

    const discType =
      profile && profile.personality ? profile.personality.disc_type : 'empty'

    return (
      <Card noPadding>
        <CardHeader
          icon={'graph'}
          title="16-Personality Types (based on types by Jung, Myers, & Briggs)"
          discType={discType}
        />
        <div className={css.testwrapper}>
          {this.renderMyersBriggsTypeToggles(mbType)}

          <div className={css.marginTop}>
            <div className={css.header}>{mbType}</div>
            <div className={css.info}>
              {generic
                ? getDescriptionGeneric(mbType)
                : getDescription(mbType, profile)}
            </div>
            <Button noMargin href={`/app/register?profile_id=${profile.id}`}>
              Sign Up Free
            </Button>
          </div>
        </div>
      </Card>
    )
  }

  renderMyersBriggsTypeToggles = (type: string | null) => {
    const { profile } = this.props
    const discType =
      profile && profile.personality ? profile.personality.disc_type : 'empty'

    return (
      <div className={css.typeToggleOptions}>
        <ToggleOption
          options={[
            { value: 'E', label: 'Extroverted' },
            { value: 'I', label: 'Introverted' },
          ]}
          value={this.dichotomy(type, 'E', 'I')}
          discType={discType}
          staticMode
        />
        <ToggleOption
          options={[
            { value: 'S', label: 'Sensing' },
            { value: 'N', label: 'Intuitive' },
          ]}
          value={this.dichotomy(type, 'S', 'N')}
          discType={discType}
          staticMode
        />
        <ToggleOption
          options={[
            { value: 'T', label: 'Thinking' },
            { value: 'F', label: 'Feeling' },
          ]}
          value={this.dichotomy(type, 'T', 'F')}
          discType={discType}
          staticMode
        />
        <ToggleOption
          options={[
            { value: 'J', label: 'Judging' },
            { value: 'P', label: 'Perceiving' },
          ]}
          value={this.dichotomy(type, 'J', 'P')}
          discType={discType}
          staticMode
        />
      </div>
    )
  }

  renderEmptyState(emptyStateCta: { text: string; onClick: () => void }) {
    const { text, onClick } = emptyStateCta

    return (
      <Card noPadding>
        <CardHeader
          icon="graph"
          title="16-Personality Types (based on types by Jung, Myers, & Briggs)"
          discType="empty"
        />
        <div className={css.testwrapper}>
          {this.renderMyersBriggsTypeToggles(null)}

          <div className={css.marginTop}>
            <div className={css.header}>Find out your 16-Personality Type</div>
            <div className={css.info}>
              Answer a few additional questions to learn more about your
              16-Personality Type.
            </div>
            <Flex>
              <Flex vertical alignCenter>
                <Button noMargin onClick={onClick}>
                  {text}
                </Button>
                {this.renderSampleLink()}
              </Flex>
            </Flex>
          </div>
        </div>
      </Card>
    )
  }

  renderSampleLink() {
    const { emptyStateCta } = this.props

    if (!emptyStateCta?.showSampleLink) return null

    return (
      <Link
        href="/p/bill-gates?show_as_own=true"
        target="_blank"
        rel="noopener noreferrer"
        className={css.sampleLink}
        passHref
      >
        View sample
      </Link>
    )
  }

  dichotomy(type: string | null, first: string, second: string) {
    if (!type) return null

    return type.toLowerCase().includes(first.toLowerCase()) ? first : second
  }
}

export default MyersBriggsModule
